module.exports = __webpack_public_path__ + "static/media/img-mygood-product-1.560505f9.png";